export const SDK_VERSION = '0.0.0';
